// src/shared/components/ui/spinner.tsx

import { cn } from '@/shared/utils/cn'

type SpinnerSize = 'xs' | 'sm' | 'md'

const spinnerSizeMap: Record<SpinnerSize, string> = {
  xs: 'h-3.5 w-3.5 border-[1.5px]',
  sm: 'h-4 w-4 border-2',
  md: 'h-5 w-5 border-2',
}

interface SpinnerProps {
  size?: SpinnerSize
  className?: string
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <span
      aria-label="Loading"
      className={cn(
        'inline-block animate-spin rounded-full border-current border-t-transparent text-[var(--color-brand)]',
        spinnerSizeMap[size],
        className,
      )}
      role="status"
    />
  )
}
